'use client';

import Link from 'next/link';
import { analyticsEvents } from '@/components/analytics/Analytics';

/**
 * Internal link that fires the existing `seo_internal_link_clicked` analytics
 * event on click, matching the pattern in HighOpportunityCourtLinks.tsx.
 * Used by the homepage Coverage section and the /courts directory page so
 * click-tracking survives the design_handoff_homepage_and_courts rewrite.
 */
export default function TrackedLink({
  href,
  surface,
  label,
  className,
  children,
}: {
  href: string;
  surface: string;
  label: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <Link
      href={href}
      onClick={() => analyticsEvents.seoInternalLinkClicked(href, surface, label)}
      className={className}
    >
      {children}
    </Link>
  );
}
